
import navigateButton from '../../assets/audio/UI_Metal_2.wav';
import { Button, Space, Typography } from 'antd';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { useGameStore, useLocationStore, useOptionsStore, useShopStore } from '../store/game.store';
import { uiRoutes } from '../../ui-routes';

interface HomePageProps extends React.PropsWithChildren { }
const WarScholarHomeProps: FC<HomePageProps> = () => {
   const { state: shopState } = useShopStore();
   const { state: locationState } = useLocationStore();

   const { gameHasStarted, gameActions } = useGameStore();
   const { state: optionsState, actions: optionsActions } = useOptionsStore();

   const playNavigationSound = () => {
      new Audio(navigateButton).play();
   };

   const handleStart = () => {
      gameActions.setGameHasStarted();
      optionsActions.playBackgroundMusic();
   };

   const handlePlay = () => {
      playNavigationSound();
      optionsActions.playBackgroundMusic();
   };

   return (
      <div className="flex my-background">
         <div style={{ width: '100%', justifyContent: 'center' }}>
            <div>
               <Space
                  direction="vertical"
                  style={{ display: 'flex', justifyContent: 'center' }}
               >
                  <div className="spacer"></div>
                  <div className="spacer"></div>
                  <div className="spacer"></div>

                  {!gameHasStarted && (
                     <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                           type="primary"
                           onClick={handleStart}
                        >
                           Start
                        </Button>
                     </div>
                  )}

                  {gameHasStarted && (
                     <div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                           <Link to={uiRoutes.play()}>
                              <button
                                 className="titleButtons"
                                 onClick={handlePlay}
                              >
                                 {' '}
                                 Play{' '}
                              </button>
                           </Link>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                           <Link to={uiRoutes.shop()}>
                              <button
                                 className="titleButtons"
                                 onClick={playNavigationSound}
                              >
                                 {' '}
                                 Shop{' '}
                              </button>
                           </Link>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                           <Link to={uiRoutes.book()}>
                              <button
                                 className="titleButtons"
                                 onClick={playNavigationSound}
                              >
                                 {' '}
                                 Book{' '}
                              </button>
                           </Link>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                           <Link to={uiRoutes.options()}>
                              <button
                                 className="titleButtons"
                                 onClick={playNavigationSound}
                              >
                                 {' '}
                                 Options{' '}
                              </button>
                           </Link>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                           <Link to={uiRoutes.credits()}>
                              <button
                                 className="titleButtons"
                                 onClick={playNavigationSound}
                              >
                                 {' '}
                                 Credits{' '}
                              </button>
                           </Link>
                        </div>
                     </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'center' }} className='homeText'>{shopState.gold} gold</div>
                  <div style={{ display: 'flex', justifyContent: 'center' }} className='homeText'>Most Days Ventured {locationState.mostDaysVentured}</div>

                  <div className="spacer"></div>
                  <div className="spacer"></div>
                  <div className="spacer"></div>

               </Space>
            </div>
         </div>
      </div>
   );
};



export const WarScholarHomePage = WarScholarHomeProps;


